(function initReifenTheme($, window) {
    "use strict";

    window.THEME = window.THEME || {};

    window.THEME.$document = $(document);

    window.THEME.name = 'Reifen';

    if (!String.prototype.capitalize) {
        String.prototype.capitalize = function capitalize() {
            return this.replace(/\w\S*/g, function replaceCallbackFunction(str) {
                return str.charAt(0).toUpperCase() + str.substr(1);
            });
        };
    }

}(window.jQuery, window));

$(function() {
    var tooltipsAdded = false;

    function escapeRegExp(value) {
        return value.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    }

    function buildTooltipMatcher(info) {
        var keys = Object.keys(info || {}).filter(function (key) {
            return Boolean(key);
        });

        if (!keys.length) {
            return null;
        }

        keys.sort(function (left, right) {
            return right.length - left.length;
        });

        return new RegExp("(^|[^A-Za-z0-9_])(" + keys.map(escapeRegExp).join("|") + ")(?=$|[^A-Za-z0-9_])", "g");
    }

    function createTooltipFragment(text, matcher, info) {
        var match;
        var lastIndex = 0;
        var fragment = document.createDocumentFragment();
        var hasReplacement = false;

        matcher.lastIndex = 0;

        while ((match = matcher.exec(text)) !== null) {
            if (match.index > lastIndex) {
                fragment.appendChild(document.createTextNode(text.substring(lastIndex, match.index)));
            }

            if (match[1]) {
                fragment.appendChild(document.createTextNode(match[1]));
            }

            fragment.appendChild($("<span/>", {
                "class": "tooltip-item",
                "data-hint": "1",
                "data-tooltip": info[match[2]],
                text: match[2]
            }).get(0));

            lastIndex = match.index + match[0].length;
            hasReplacement = true;
        }

        if (!hasReplacement) {
            return null;
        }

        if (lastIndex < text.length) {
            fragment.appendChild(document.createTextNode(text.substring(lastIndex)));
        }

        return fragment;
    }

    function replaceTooltipTextNodes(node, matcher, info) {
        var hasReplacement = false;

        $(node).contents().each(function () {
            var fragment;

            if (this.nodeType === 3) {
                fragment = createTooltipFragment(this.nodeValue, matcher, info);

                if (fragment) {
                    this.parentNode.replaceChild(fragment, this);
                    hasReplacement = true;
                }

                return;
            }

            if (this.nodeType === 1 && !$(this).hasClass("tooltip-item") && replaceTooltipTextNodes(this, matcher, info)) {
                hasReplacement = true;
            }
        });

        return hasReplacement;
    }

    $(".extrainfo-hint").each(function () {
        var $el = $(this);
        var info = $el.data("info");
        var tooltipMatcher;

        if (!info || typeof info !== "object") {
            return;
        }

        tooltipMatcher = buildTooltipMatcher(info);
        if (!tooltipMatcher) {
            return;
        }

        if (replaceTooltipTextNodes(this, tooltipMatcher, info)) {
            tooltipsAdded = true;
        }
    });

    //new tooltips were added; they need to be initialized
    if (tooltipsAdded) {
        window.THEME.initTooltips();
    }

});